import { create } from "zustand";
import { AuthStore } from "../@types/auth";
import { devtools } from "zustand/middleware";
import createAuthSlice from './slices/createAuthSlice'
import createUsersSlice from './slices/createUsersSlice'
import createMasterSlice from './slices/createMasterSlice'
import createControllerSlice from './slices/createControllerSlice'
import createSimulationSlice from './slices/createSimulationSlice'
import { ControllerStore, MasterStore, SimulationStore, UsersStore } from "../@types/store";

export const useGlobalStore = create<AuthStore & MasterStore & UsersStore & ControllerStore & SimulationStore>()(devtools((...a) => ({
    ...createAuthSlice(...a),
    ...createMasterSlice(...a),
    ...createUsersSlice(...a),
    ...createControllerSlice(...a),
    ...createSimulationSlice(...a)
})))
